import React from 'react';
import marked from 'marked';
import sanitizeHtml from 'sanitize-html';
import Prism from 'prismjs';
import _debounce from 'lodash.debounce';
import PrismJsx from 'prismjs/components/prism-jsx.min';

import 'prismjs/themes/prism.css';

import './CommentBody.css';

class CommentBody extends React.Component {

    body = React.createRef();
    mounted = false;

    state = {
        overflowing: false,
        expanded: false
    };

    checkOverflow = _debounce(() => {

        if (this.body.current && this.mounted) {
            this.setState({
                overflowing: this.body.current.scrollHeight > this.body.current.clientHeight
            });
        }

    }, 150);

    onToggleExpand = e => {

        this.setState({ expanded: !this.state.expanded });
    };

    componentDidMount() {
        this.mounted = true;
        Prism.highlightAllUnder(this.body.current);
        window.addEventListener('resize', this.checkOverflow);
        this.checkOverflow();
    }

    componentDidUpdate(prevProps) {

        if (prevProps.value !== this.props.value) {
            Prism.highlightAllUnder(this.body.current);
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener('resize', this.checkOverflow);
    }

    get toggleExpand() {

        if (!this.state.overflowing) {
            return null;
        }

        const { expanded } = this.state;

        return (
            <button onClick={this.onToggleExpand}>
                <span className={`icon-unfold_${expanded ? 'less' : 'more'}`} /> show {expanded ? 'less' : 'more'}
            </button>
        );
    }

    render() {

        const html = marked(this.props.value, {
            breaks: true
        });

        const cleanHtml = sanitizeHtml(html, {
            allowedTags: [ 'b', 'i', 'em', 'strong', 'br', 'p', 'pre', 'code', 'blockquote' ],
            allowedAttributes: {
                'code': ['class']
            }
        });

        const classNames = [ 'comment-body' ];

        if (this.state.overflowing) {
            classNames.push('overflowing');
        }
        if (this.state.expanded) {
            classNames.push('expanded');
        }

        return (
            <div className={classNames.join(' ')}>
                <div
                    ref={this.body}
                    dangerouslySetInnerHTML={{
                        __html: cleanHtml
                    }}
                />
                {this.toggleExpand}
            </div>
        );
    }
}

export default CommentBody;


// WEBPACK FOOTER //
// ./src/components/CommentBody.jsx